module.exports = __webpack_public_path__ + "img/secretaria.bf654c42.png";